import {
  CopyValue,
  FixedToolbarItem,
  FlexToolbarItem,
  ScrollingTextArea,
  Toolbar,
  useAATheme,
} from "@bagel-web/components";
import { useState } from "react";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { darkStyles, defaultStyles, JsonView } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";

const JsonLog = ({
  id,
  data,
  title,
}: {
  id: string;
  data: object;
  title?: string;
}) => {
  const [showRaw, setShowRaw] = useState<boolean>(false);
  const { isDarkMode } = useAATheme();
  const raw = JSON.stringify(data);
  return (
    <div style={{ width: "100%" }}>
      <Toolbar>
        <FlexToolbarItem>{title && <h5>{title}</h5>}</FlexToolbarItem>
        <FixedToolbarItem>
          <CopyValue value={raw} />
        </FixedToolbarItem>
        <FixedToolbarItem>
          <ButtonGroup>
            <ToggleButton
              id={`${id}-raw-log-toggle`}
              value="show-raw-log"
              type="radio"
              variant="outline-secondary"
              checked={showRaw}
              onChange={() => setShowRaw(true)}
            >
              Raw
            </ToggleButton>
            <ToggleButton
              id={`${id}-pretty-log-toggle`}
              value="show-pretty-log"
              type="radio"
              variant="outline-secondary"
              checked={!showRaw}
              onChange={() => setShowRaw(false)}
            >
              Pretty
            </ToggleButton>
          </ButtonGroup>
        </FixedToolbarItem>
      </Toolbar>
      <div className="mt-3 font-monospace" style={{ fontSize: "0.875rem" }}>
        <ScrollingTextArea
          $maxHeight="500px"
          $backgroundColor="var(--aa-surface-bg)"
        >
          {showRaw ? (
            <code
              style={{
                color: "var(--aa-code-color)",
              }}
            >
              {raw}
            </code>
          ) : (
            <div
              style={{
                padding: "0.875rem 1rem",
              }}
            >
              <JsonView
                data={data}
                style={{
                  ...(isDarkMode ? darkStyles : defaultStyles),
                  container: "",
                  label: "aa-json-label",
                  stringValue: "aa-json-string",
                  numberValue: "aa-json-number",
                  booleanValue: "aa-json-boolean",
                  nullValue: "aa-json-null",
                  undefinedValue: "aa-json-undefined",
                  punctuation: "aa-json-punctuation",
                }}
              />
            </div>
          )}
        </ScrollingTextArea>
      </div>
    </div>
  );
};

export default JsonLog;
